import React from 'react';

import SearchFTUXIcon from '../../../assets/icons/SearchFTUXIcon';
import styles from './searchFTUX.module.css';

interface SearchFTUXInterface {
  text: string | React.ReactNode;
  className?: string;
  icon?: string | React.ReactNode;
  iconColor?: string;
}

export default function SearchFTUX({ text, className, icon, iconColor = '#424242' }: SearchFTUXInterface) {
  return (
    <div className={`${styles.searchFtuxContainer} ${className}`}>
      {icon || <SearchFTUXIcon color={iconColor} />}
      <p className={styles.searchFtuxText}>{text}</p>
    </div>
  );
}
